import { gql, useQuery } from "@apollo/client";

export const PERFORMER_NAME_QUERY = gql`
  query EpocusPerformerName($userIds: [ID!]!) {
    epocusPeople(userIds: $userIds) {
      userId
      displayName
    }
  }
`;

type PerformerNameData = {
  epocusPeople?: { userId: string; displayName: string }[] | null;
};

export const UNASSIGNED_PERFORMER_LABEL = "Unassigned";

export const usePerformerName = (
  performerId: string | null | undefined,
): { displayName: string; loading: boolean } => {
  const { data, loading } = useQuery<PerformerNameData>(PERFORMER_NAME_QUERY, {
    variables: { userIds: performerId ? [performerId] : [] },
    fetchPolicy: "cache-first",
    skip: !performerId,
  });

  const resolvedName =
    (data?.epocusPeople ?? [])
      .find((person) => person.userId === performerId)
      ?.displayName.trim() || null;

  if (!performerId) {
    return { displayName: UNASSIGNED_PERFORMER_LABEL, loading: false };
  }

  const truncatedId =
    performerId.length > 8 ? `…${performerId.slice(-8)}` : performerId;

  return {
    displayName: resolvedName ?? truncatedId,
    loading: loading && resolvedName == null,
  };
};
